<!--
* @Name：验收确认单
* @Author: 王超
* @Date: 2025-10-28
-->
<template>
  <div>
    <hi-cell title="合同验收单编号：" :value="headInfo.applyCode"></hi-cell>
    <hi-cell title="验收单名称：" :value="headInfo.applyTitle"></hi-cell>
    <hi-cell title="验收单类型：" :value="headInfo.receiveOrderType" :options="receiveOrderTypeOptions"></hi-cell>
    <hi-cell title="验收类型：" :value="headInfo.contractReceiveMode" :options="contractReceiveModeOptions"></hi-cell>
    <hi-cell title="币种：" :value="headInfo.currencyDict" :options="currencyDictOptions"></hi-cell>
    <hi-cell title="合同编号：" :value="headInfo.contractCode"></hi-cell>
    <hi-cell title="采购合同名称：" :value="headInfo.contractTitle"></hi-cell>
    <hi-cell title="合同总金额：" :value="headInfo.sumAmount"></hi-cell>
    <hi-cell title="已验收金额：" :value="headInfo.sumAccepteTookAmount"></hi-cell>
    <hi-cell title="剩余未验收金额：" :value="headInfo.leftSumAccepteTookAmount"></hi-cell>
    <hi-cell title="本次验收金额：" :value="headInfo.sumAccepteAmount"></hi-cell>
    <hi-cell title="备注：" :value="headInfo.remark"></hi-cell>
    <hi-cell title="申请人：" :value="headInfo.crtUserName"></hi-cell>
    <hi-cell title="申请时间：" :value="headInfo.crtTime"></hi-cell>
    <hi-cell title="U9收货单创建信息：" :value="headInfo.erpCreateInfo"></hi-cell>
    <van-row>
      <van-button type="info" size="normal" style="margin-left: 16px" @click="clickAttachmentList()">附件</van-button>
    </van-row>
    <attachment-info
      v-if="attachmentDialogVisible"
      :details-visible="attachmentDialogVisible"
      :attach-list="attachmentListItem"
      @close-details-dialog="attachmentDialogVisible = false"
    />
  </div>
</template>

<script>
export default {
  name: 'BaseInfo',
  components: {
    'attachment-info': () => import('./AttachmentInfo')
  },
  data() {
    return {
      attachmentDialogVisible: false,
      attachmentListItem: []
    }
  },
  props: {
    headInfo: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    receiveOrderTypeOptions() {
      return this.$store.getters.dicts.receive_order_type
    },
    contractReceiveModeOptions() {
      return this.$store.getters.dicts.acceptance_method
    },
    currencyDictOptions() {
      return this.$store.getters.dicts.currency_dict
    }
  },
  methods: {
    clickAttachmentList() {
      this.attachmentListItem = this.headInfo.contractAccepteApplyFiles
      this.attachmentDialogVisible = true
    }
  }
}
</script>
